// Componente per sistema ExeDialog DDT2026 - Step rag_soc_vettore e vett_ns
// Autocomplete che chiama verificaDdt ad ogni carattere digitato
// Con tabella suggerimenti vettori recenti
import React, { useState, useRef, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ValoriVerificati } from './ValoriVerificati';

export function RagSocVettore(props) {
    const { currURLSearchParams, onFinish, verificaData, verificaDdt, buildInputFromSearchParams } = props;
    const inputRef = useRef();
    
    const [state, setState] = useState({
        rag_soc_vettore: currURLSearchParams.get('rag_soc_vettore') || 'NO vettore',
        vett_ns: currURLSearchParams.get('vett_ns') === 'true'
    });
    const [suggestions, setSuggestions] = useState([]);
    const [searching, setSearching] = useState(false);

    // righe_suggerimento dalla risposta iniziale (vettori recenti)
    const suggerimenti = verificaData?.righe_suggerimento || [];

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [verificaData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.rag_soc_vettore) {
            onFinish({
                rag_soc_vettore: state.rag_soc_vettore,
                vett_ns: state.vett_ns
            });
        }
    };

    // Selezionando una riga dalla tabella suggerimenti
    const handleRowSelect = (e) => {
        const row = e.data;
        onFinish({
            rag_soc_vettore: row.rag_soc_vettore,
            vett_ns: state.vett_ns
        });
    };

    // Chiama verificaDdt ad ogni carattere digitato
    const searchOptions = async (event) => {
        const query = event.query;
        if (!query || query.length < 1) {
            setSuggestions([]);
            return;
        }

        setSearching(true);
        try {
            const currentInput = buildInputFromSearchParams(currURLSearchParams);
            const input = {
                ...currentInput,
                rag_soc_vettore: query
            };
            
            const result = await verificaDdt(input);
            // Se il campo è stato verificato (campo_da_verificare è passato al successivo),
            // mostra il valore verificato come unica opzione confermabile
            if (result?.campo_da_verificare !== 'rag_soc_vettore') {
                const v = result?.valori_verificati;
                setSuggestions(v?.rag_soc_vettore ? [{ rag_soc_vettore: v.rag_soc_vettore, cod_vettore: v.cod_vettore }] : []);
            } else {
                setSuggestions(result?.opzioni_selezione || []);
            }
        } catch (err) {
            console.error('Errore ricerca:', err);
            setSuggestions([]);
        } finally {
            setSearching(false);
        }
    };

    const itemTemplate = (item) => (
        <span>{item.rag_soc_vettore} <span style={{fontSize: 'x-small', color: '#666'}}>({item.cod_vettore})</span></span>
    );

    return (
        <div className="card-body">
            <h5 className="card-title">Vettore</h5>
            <p className="text-muted">Digita per cercare il vettore o seleziona dalla tabella.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="rag_soc_vettore" className="form-label">Ragione Sociale Vettore</label>
                    <AutoComplete 
                        ref={inputRef}
                        id="rag_soc_vettore"
                        value={state.rag_soc_vettore}
                        suggestions={suggestions}
                        completeMethod={searchOptions}
                        field="rag_soc_vettore"
                        onChange={(e) => {
                            const value = typeof e.value === 'object' ? e.value.rag_soc_vettore : e.value;
                            setState({ ...state, rag_soc_vettore: value });
                        }}
                        onSelect={(e) => setState({ ...state, rag_soc_vettore: e.value.rag_soc_vettore })}
                        itemTemplate={itemTemplate}
                        className="w-100"
                        inputClassName="w-100"
                        minLength={1}
                        delay={300}
                    />
                    {searching && <small className="text-muted">Ricerca in corso...</small>}
                </div>

                <div className="mb-3 form-check">
                    <Checkbox 
                        id="vett_ns"
                        checked={state.vett_ns}
                        onChange={(e) => setState({ ...state, vett_ns: e.checked })}
                    />
                    <label htmlFor="vett_ns" className="form-check-label ms-2">
                        Vettore a carico nostro
                    </label>
                </div>

                {suggerimenti.length > 0 && (
                    <div className="card mb-3">
                        <DataTable 
                            value={suggerimenti} 
                            selectionMode="single" 
                            onRowSelect={handleRowSelect}
                            size="small"
                            scrollable
                            scrollHeight="500px"
                            header="Vettori recenti"
                            filterDisplay="row"
                        >
                            <Column field="rag_soc_vettore" header="Ragione Sociale" sortable filter showFilterMenu={false} />
                        </DataTable>
                    </div>
                )}

                <button className="btn btn-primary" disabled={!state.rag_soc_vettore}>
                    Prosegui
                </button>
            </form>
            
            <ValoriVerificati valori={verificaData?.valori_verificati} />
        </div>
    );
}

RagSocVettore.displayName = 'rag_soc_vettore';
